import { Reveal } from "./Reveal";
import { ArrowUpRight } from "lucide-react";

const FAVORITES = [
  { label: "Affiliate Links", href: "#" },
  { label: "Recommended Creative Tools", href: "#" },
  { label: "Business Tools We Love", href: "#" },
];

const SOCIALS = [
  { label: "Instagram", href: "#" },
  { label: "Behance", href: "#" },
  { label: "LinkedIn", href: "#" },
  { label: "Dribbble", href: "#" },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0b0618] border-t border-[#2D1B4E] pt-24 pb-10"
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-12">
        {/* Massive CTA */}
        <Reveal>
          <a
            href="#contact"
            data-testid="footer-cta"
            className="group block"
          >
            <div className="font-display font-extrabold tracking-tight text-white leading-[0.9] text-5xl sm:text-7xl lg:text-[9rem]">
              <span className="inline-flex items-center gap-4 group-hover:text-[#C77DFF] transition-colors duration-500">
                Start a Project
                <ArrowUpRight className="h-10 w-10 lg:h-24 lg:w-24 text-[#8A2BE2] group-hover:rotate-45 transition-transform duration-500" />
              </span>
            </div>
          </a>
        </Reveal>

        <div className="mt-24 grid md:grid-cols-4 gap-10 border-t border-[#2D1B4E] pt-14">
          <div className="md:col-span-2">
            <div className="flex items-center">
              <span className="font-display font-extrabold text-2xl text-white">
                CMD<span className="text-[#C77DFF]">+</span>DesignLab
                <sup className="align-super text-[0.5em] text-[#C77DFF] ml-0.5">
                  &reg;
                </sup>
              </span>
            </div>
            <p className="mt-4 text-[#B5A6CC] max-w-sm leading-relaxed">
              Bold, strategic visual solutions for businesses, organizations,
              events and special projects.
            </p>
            <a
              href="mailto:hello@cmddesignlab.com"
              className="mt-6 inline-block text-white link-underline"
            >
              hello@cmddesignlab.com
            </a>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.3em] text-[#C77DFF] mb-5">
              Lab Favorites
            </h4>
            <ul className="space-y-3">
              {FAVORITES.map((f) => (
                <li key={f.label}>
                  <a
                    href={f.href}
                    data-testid={`footer-fav-${f.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-[#B5A6CC] hover:text-white transition-colors duration-300"
                  >
                    {f.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.3em] text-[#C77DFF] mb-5">
              Social
            </h4>
            <ul className="space-y-3">
              {SOCIALS.map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    data-testid={`footer-social-${s.label.toLowerCase()}`}
                    className="text-[#B5A6CC] hover:text-white transition-colors duration-300"
                  >
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col md:flex-row items-center justify-between gap-4 border-t border-[#2D1B4E] pt-8 text-sm text-[#6d5b95]">
          <span>© {new Date().getFullYear()} CMD+DesignLab&reg;. All rights reserved.</span>
          <span>Designed with purpose in the Lab.</span>
        </div>
      </div>
    </footer>
  );
}
